import $ from "jquery";

("use strict");

const LOGIN_BOX_MENU = {
    IS_ACTIVE: 'is-active',
    SELECTOR_ITEM_MENU: '.dcw_login_notif',
    SELECTOR_JS_RELATED_MENU: '.JS--relatedLinkedList',
    SELECTOR_CONTAINER_HEADER: '.dcw_main-nav_list',
    SELECTOR_SUBMENU_ITEM: '.js-submenu_item',
    SELECTOR_SUBMENU_MARKER: '.js-marker',
    PROP_DATA_CHANNEL_ID: 'data-channelid',
    INITIAL_2NDMARKER_POS: 0,
    SELECTOR_REFERENCE_ELT : ".js-ref_elt"
};

// default values
var $container = null;
var $menuToDisplay = null;
var $jsRelatedMenus = null;
var $subMenuBarItemActive = null;
var currentPageIsActive = false;

export function processLoginBoxMenu() {
    if (window.cmsUtil.currentChannelBreadcrumb != undefined) {
        $jsRelatedMenus = $(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU);
        $container = $(LOGIN_BOX_MENU.SELECTOR_CONTAINER_HEADER);
        var channels = window.cmsUtil.currentChannelBreadcrumb.split(",");

        // channels.length-1 to remove home channel
        for (var i = 0; i < channels.length - 1; i++) {
            var currentChannelIdFromBreadcrumb = channels[i];

            // Check first level of Login box menu
            processActiveItems(currentChannelIdFromBreadcrumb);

            if (currentPageIsActive) {
                break;
            }

            // Check second level of Login box menu
            processActiveSubMenuItems(currentChannelIdFromBreadcrumb);
        }

        // check if external URL match in case of only transactional
        if (!currentPageIsActive) {
            processActiveItemsIfExternalLink();
        }

        if (currentPageIsActive) {
            $menuToDisplay.removeClass(LOGIN_BOX_MENU.CLASS_IS_HIDDEN);
            //initMarker();
        } else {
            $jsRelatedMenus.remove();
        }
    }

}

/**
 * highlight corresponding icon and generate related menu
 */
function processActiveItems(currentChannelIdFromBreadcrumb) {
    var $item = $(LOGIN_BOX_MENU.SELECTOR_ITEM_MENU + "[" + LOGIN_BOX_MENU.PROP_DATA_CHANNEL_ID + "=" + currentChannelIdFromBreadcrumb + "]");

    if($item.length) {
        $item.addClass(LOGIN_BOX_MENU.IS_ACTIVE);
        if ($item.next(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU).length) {
            $menuToDisplay = $($item.next(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU).html());

            // display related Menu
            $menuToDisplay.prependTo($container);
            currentPageIsActive = true;
        }
    }
}

/**
 * highlight corresponding icon checking the path (for external app context, if no channel link from the CMS)
 */
function processActiveItemsIfExternalLink() {
    var path = window.location.pathname;
    path = path.replace(/\/$/, "");
    path = decodeURIComponent(path);

    $(LOGIN_BOX_MENU.SELECTOR_ITEM_MENU).each(function () {
        var $this = $(this);
        var href = $this.attr("href").replace(/\/$/, "");
        href = href.replace(/#.*$/,"");

        if (href != undefined && href === path.substring(0, href.length)) {
            $this.addClass(LOGIN_BOX_MENU.IS_ACTIVE);
            currentPageIsActive = true;

            if ($this.next(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU).length) {
                $menuToDisplay = $($this.next(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU).html());
                $menuToDisplay.prependTo($container);
            }
        }
    });
}

/**
 * highlight corresponding icon and corresponding menu item of submenu
 */
function processActiveSubMenuItems(currentChannelIdFromBreadcrumb) {
    $jsRelatedMenus.each(function () {
        var $currentRelatedMenu = $(this);
        var activeLink = $currentRelatedMenu.find(LOGIN_BOX_MENU.SELECTOR_SUBMENU_ITEM + " " + LOGIN_BOX_MENU.SELECTOR_REFERENCE_ELT + "[" + LOGIN_BOX_MENU.PROP_DATA_CHANNEL_ID + "=" + currentChannelIdFromBreadcrumb + "]");

        if(activeLink.length) {
            $subMenuBarItemActive = activeLink.parents(LOGIN_BOX_MENU.SELECTOR_SUBMENU_ITEM);

            // skip it if no subMenu Item
            if (!$subMenuBarItemActive.length) {
                return true;
            }

            // add class on current Menu Element
            $subMenuBarItemActive.addClass(LOGIN_BOX_MENU.IS_ACTIVE);

            // get global menu to display
            $menuToDisplay = $currentRelatedMenu.children();

            if (!$menuToDisplay.length) {
                return;
            }

            // Add class to current section in login box menu
            if ($currentRelatedMenu.prev(LOGIN_BOX_MENU.SELECTOR_ITEM_MENU).length) {
                $currentRelatedMenu.prev(LOGIN_BOX_MENU.SELECTOR_ITEM_MENU).addClass(LOGIN_BOX_MENU.IS_ACTIVE);
            }

            // display related Menu
            $menuToDisplay.prependTo($(LOGIN_BOX_MENU.SELECTOR_CONTAINER_HEADER));
            currentPageIsActive = true;

            // break the current loop
            return false;
        }
    });
}

/**
 * init javascript marker and translate it to the right position
 */
function initMarker() {
    var $currentMarker = $menuToDisplay.find(LOGIN_BOX_MENU.SELECTOR_SUBMENU_MARKER);

    if ((!$subMenuBarItemActive.length) || (!$currentMarker.length)) {
        return false;
    }

    var positionActiveItem = $subMenuBarItemActive.position();
    if (positionActiveItem) {
        $currentMarker.css('transform', 'translateX('+ positionActiveItem.left +'px) scaleX(1)');
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/menu.js